import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { UiSwitchModule } from 'ngx-ui-switch';

import { ProviderPayratesHistoryComponent } from './components/provider-payrates-history/provider-payrates-history.component';
import { ProviderPayratesProvider } from './containers/provider-payrates/provider-payrates.provider';
import { ProviderPayratesHistoryProvider } from './components/provider-payrates-history/provider-payrates-history.provider';
import { BrowserModule } from '@angular/platform-browser';
import { ProviderPayratesComponent } from './containers/provider-payrates/provider-payrates.component';
import { UtilsModule } from '@bayclubs/utils';
import { ProviderPayratesEditComponent } from './components/provider-payrates-edit/provider-payrates-edit.component';
import { ProviderCurrentPayratesComponent } from './components/provider-current-payrates/provider-current-payrates.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropDownModule } from '@bayclubs/drop-down';
import { InfrastructureModule } from '../infrastructure/infrastructure.module';



@NgModule({
  declarations: [
    ProviderPayratesComponent, 
    ProviderPayratesHistoryComponent,
    ProviderPayratesEditComponent,
    ProviderCurrentPayratesComponent,
],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    UiSwitchModule,
    UtilsModule,
    DropDownModule,
    InfrastructureModule
  ]
})
export class GroupClassesActionsModule { }

export { ProviderPayratesProvider }
export { ProviderPayratesHistoryProvider }
export { ProviderPayratesFormBuilderService } from './services/provider-payrates-form-builder.service';
